<div
  class="carousel"
  id="mit-forbrug-carousel"
  role="region"
  aria-roledescription="carousel"
  [attr.aria-label]="showCarousel ? 'Karussel med forbrugs tiles' : 'Forbrugs tiles'"
  >
  <!-- Navigation Buttons -->
  <div class="carousel__button-wrapper">
    @if (showCarousel) {
      <button class="carousel-prev" (click)="prev()" [disabled]="currentIndex === 0" aria-label="Tidligere slide" role="button" type="button">
        <mat-icon svgIcon="arrow-left"></mat-icon>
      </button>
    }
    @if (showCarousel) {
      <button
        class="carousel-next"
        (click)="next()"
        [disabled]="currentIndex === cardsArray.length - 1"
        aria-label="Næste slide"
        role="button"
        type="button"
        >
        <mat-icon svgIcon="arrow-right"></mat-icon>
      </button>
    }
  </div>

  <!-- Carousel Wrapper with aria-live for screen readers -->
  <div
    class="carousel__wrapper"
    [ngStyle]="{ transform: 'translateX(-' + currentIndex * (isMobile ? 345 : 364) + 'px)' }"
    aria-live="polite"
    aria-atomic="true"
    id="carousel-slides"
    role="region"
    [attr.aria-label]="'Slide ' + (currentIndex + 1) + ' af ' + cardsArray.length"
    tabindex="0"
    aria-labelledby="carousel-heading"
    style="outline: none"
    >
    <h2 id="carousel-heading" class="sr-only">{{ showCarousel ? "Karussel med forbrugs tiles" : "Forbrugs tiles" }}</h2>
    @for (card of cardsArray; track card; let i = $index) {
      <ng-content
        select="[appCarouselCard]"
        [attr.id]="'slide' + i"
        [attr.aria-hidden]="i !== currentIndex"
        [attr.tabindex]="i === currentIndex ? '0' : '-1'"
        [attr.role]="i === currentIndex ? 'group' : null"
      ></ng-content>
    }
  </div>

  <!-- Indicators for screen readers and keyboard navigation -->
  @if (showCarousel) {
    <div class="carousel__indicators" role="tablist">
      @for (card of cardsArray; track card; let i = $index) {
        <button
          (click)="goToSlide(i)"
          [class.active]="i === currentIndex"
          [attr.aria-selected]="i === currentIndex ? true : false"
          [attr.aria-controls]="'slide' + i"
          [attr.aria-label]="'Gå til slide ' + (i + 1)"
          [attr.id]="'indicator' + i"
          role="tab"
          tabindex="0"
          class="indicator"
        ></button>
      }
    </div>
  }
</div>
